import {LOADED, LOADING} from "./communication";
import {WaError} from "../types/config";

export type Wrapped<T> = {
    statusCode: number
    data: T | null
    errorMessage: WaError | null
}

export function loaded<T>(x : T) : Wrapped<T> {
    return {
        statusCode: LOADED,
        data: x,
        errorMessage: null
    }
}

export function loading<T>(x : T) : Wrapped<T> {
    return {
        statusCode: LOADING,
        data: x,
        errorMessage: null
    }
}

export function wrapStatus<T>(response: Promise<Response>): Promise<Wrapped<T>> {
    return response.then((response) => {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
            return (response.json()).then(r => {
                return {statusCode: response.status, data: r, errorMessage: null}
            });
        } else {
            return (response.text()).then(text => {
                return {statusCode: response.status, data: text, errorMessage: null}
            });
        }
    }).catch((error) => {
        console.table(error)
        return {statusCode: 1, data: null, errorMessage: error.toString()};
    });
}